import SageScreen from "kit/SageScreen";
import React from "react";
import styles from "./BalanceMinutes.module.scss";
import classnames from "classnames";
import BalanceMinutesEarned from "./balanceMinutes/BalanceMinutesEarned";
import BalanceMinutesSpent from "./balanceMinutes/BalanceMinutesSpent";
import RequireData from "hooks/RequireData";
import userSelector from "selectors/user";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import { fetchUser } from "actions/user";
import { Link } from "react-router-dom";
import { minutesToString } from "utils/minutesFormat";

const BalanceMinutes: React.FC = () => {
    const [isEarned, setIsEarned] = React.useState(true);

    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const earnedClicked = React.useCallback(() => {
        setIsEarned(true);
    }, [setIsEarned]);

    const spentClicked = React.useCallback(() => {
        setIsEarned(false);
    }, [setIsEarned]);

    return (
        <SageScreen>
            <h2>
                Minutes Balance:{" "}
                {user === null
                    ? "loading..."
                    : minutesToString(user.minutes_balance)}{" "}
                minutes
            </h2>
            <Link
                className={classnames(
                    "btn",
                    "btn-sm",
                    "btn-outline-primary",
                    styles.rightMarginButton
                )}
                to="/home/dashboard/balance/minutes/sell"
            >
                Sell Minutes
            </Link>
            <Link
                className={classnames(
                    "btn btn-sm btn-outline-primary",
                    styles.rightMarginButton
                )}
                to="/home/dashboard/balance/minutes/sales-record"
            >
                Sales Records
            </Link>
            <Link
                to="/home/dashboard/balance/minutes/order"
                className={classnames(
                    "btn btn-sm btn-outline-primary",
                    styles.rightMarginButton
                )}
            >
                Order Minutes
            </Link>
            <Link
                to="/home/dashboard/balance/minutes/orders-record"
                className="btn btn-outline-primary btn-sm"
            >
                Order Records
            </Link>
            <hr />
            <div
                className={classnames(
                    "row align-item-center",
                    styles.buttonContainer
                )}
            >
                <div className="col">
                    <div className="btn-group" role="group">
                        <button
                            onClick={earnedClicked}
                            type="button"
                            className={classnames(
                                "btn",
                                isEarned ? "btn-primary" : "btn-light"
                            )}
                        >
                            Earned
                        </button>
                        <button
                            onClick={spentClicked}
                            type="button"
                            className={classnames(
                                "btn",
                                !isEarned ? "btn-primary" : "btn-light"
                            )}
                        >
                            Spent
                        </button>
                    </div>
                </div>
            </div>
            {isEarned ? <BalanceMinutesEarned /> : <BalanceMinutesSpent />}
        </SageScreen>
    );
};

export default BalanceMinutes;
